import api from './axios';

// List all KPIs (with optional existing reviews) for direct reports for a given review type
export async function listManagedKpiReviews(reviewTypeId) {
    const { data } = await api.get('/api/reviews/managed', { params: { review_type: reviewTypeId } });
    return data; // { review_type, data: [{ employee:{id,name,email}, kpi:{...}, review: {...}|null }] }
}


// List direct reports for current manager
export async function listManagedEmployeesV1(params = {}) {
    const { data } = await api.get('/api/reviews/managed/employees', { params });
    return data; // legacy: { manager: {...}, employees: [{id,name,email}, ...] }
}

// Manager view: KPI rows for ONE employee & review type
export async function listManagedKpiReviewsForEmployee(reviewTypeId, employeeId) {
    const { data } = await api.get('/api/reviews/managed', {
        params: { review_type_id: reviewTypeId, employee_id: employeeId }
    });
    return data; // { review_type, data:[{employee,kpi,review}, ...] }
}


export async function updateManagerReview(reviewId, payload) {
    // Calls PUT /api/reviews/{review}/manager
    const { data } = await api.put(`/api/reviews/${reviewId}/manager`, payload);
    return data;
}


export async function listManagedEmployees(params = {}) {
    const { data } = await api.get('/api/reviews/managed/employees', { params });

    // New API shape: { manager: {...}, data: { data: [...], current_page, ... } }
    if (data?.data && Array.isArray(data.data?.data)) {
        const paginator = data.data;
        return {
            employees: paginator.data,
            meta: {
                current_page: paginator.current_page ?? 1,
                last_page: paginator.last_page ?? 1,
                per_page: paginator.per_page ?? params.per_page ?? 15,
                total: paginator.total ?? paginator.data.length ?? 0,
            },
            manager: data.manager ?? null,
        };
    }

    // Legacy fallbacks
    if (Array.isArray(data?.employees)) {
        return {
            employees: data.employees,
            meta: {
                current_page: 1,
                last_page: 1,
                per_page: data.employees.length,
                total: data.employees.length,
            },
            manager: data.manager ?? null,
        };
    }
    if (Array.isArray(data)) {
        return {
            employees: data,
            meta: {
                current_page: 1,
                last_page: 1,
                per_page: data.length,
                total: data.length,
            },
            manager: null,
        };
    }

    return {
        employees: [],
        meta: { current_page: 1, last_page: 1, per_page: params.per_page ?? 15, total: 0 },
        manager: null,
    };
}
